module.exports = __webpack_public_path__ + "img/chevron-up.5df2f567.svg";